import { type PaymentBreakdown, BreakdownTypes } from '../../types/PaymentBreakdown';
import { t } from '.';

export type BreakdownLabelKey = keyof PaymentBreakdown | 'itemsTotal';

const paymentBreakdownTypesMap: Record<BreakdownLabelKey, string> = {
  [BreakdownTypes.Tax]: 'tax',
  [BreakdownTypes.Shipping]: 'shipping',
  [BreakdownTypes.Discount]: 'discount',
  itemsTotal: 'itemsTotal',
};

export const getBreakdownLocaleKey = (type: BreakdownLabelKey): string =>
  `paymentSheet.paymentBreakdown.${paymentBreakdownTypesMap[type]}`;

export const getLocalizeBreakdownLabel = (type: BreakdownLabelKey): string => t(getBreakdownLocaleKey(type));
